import React, { useState } from 'react';
import { attachmentApi } from '../../services/api';

interface AttachmentListProps {
  attachmentIds: string[];
  showDownload?: boolean;
}

const AttachmentList: React.FC<AttachmentListProps> = ({ 
  attachmentIds, 
  showDownload = true 
}) => {
  const [downloading, setDownloading] = useState<string | null>(null);

  const handleDownload = async (attachmentId: string) => {
    try {
      setDownloading(attachmentId);
      const attachment = await attachmentApi.getDownloadUrl(attachmentId);
      
      // Open download URL in new tab
      if (attachment.downloadUrl) {
        window.open(attachment.downloadUrl, '_blank');
      } else {
        console.error('No download URL available for attachment');
      }
    } catch (error) {
      console.error('Error downloading attachment:', error);
    } finally {
      setDownloading(null);
    }
  };

  if (!attachmentIds || attachmentIds.length === 0) {
    return (
      <span className="text-sm text-gray-400">Sin adjuntos</span>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {attachmentIds.map((attachmentId, index) => (
        <button
          key={attachmentId}
          onClick={() => showDownload && handleDownload(attachmentId)}
          disabled={downloading === attachmentId || !showDownload}
          className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-md ${
            showDownload
              ? 'bg-blue-50 text-blue-700 hover:bg-blue-100 cursor-pointer'
              : 'bg-gray-50 text-gray-700 cursor-default'
          } ${downloading === attachmentId ? 'opacity-50' : ''}`}
          title={showDownload ? 'Descargar adjunto' : 'Adjunto'}
        >
          {downloading === attachmentId ? (
            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-600"></div>
          ) : (
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
              />
            </svg>
          )}
          <span>Adjunto {index + 1}</span>
        </button>
      ))}
    </div>
  );
};

export default AttachmentList;
